<template>
	<div class="t-page_courses t-work-area">
		<h1 class="_padding">
			{{ course.name }}
			<router-link :to="{name: 'courses'}" v-if="!mobileState">
				<svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M1 4H13M1 4L5 1M1 4L5 7" stroke="#52A8F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>
				{{ pageText.back }}
			</router-link>
		</h1>

		<p class="t-black-list-hint" v-if="blackList">{{ pageText.blackList }}</p>


		<template v-if="hasAuth">
			<cmp-tabs v-if="course.belonging" :data="[{title: tabs.info, url: 'courses_info'},{title: tabs.applications, url: 'courses_applications'}]"></cmp-tabs>
			<cmp-tabs :data="[{title: tabs.info, url: 'courses_info'},{title: tabs.history, url: 'courses_history'}]" v-else></cmp-tabs>
		</template>
		<cmp-tabs :data="[{title: tabs.info, url: 'courses_info'}]" v-else></cmp-tabs>

		<router-view></router-view>
	</div>
</template>

<script>
    let tabsText = {
        url: process.env.NODE_ENV !== 'production' ? 'staticText/courseTabs.json' : 'staticText',
        tabs: {
            info: "Информация",
            history: "История",
            applications: "Заявки",
            edit: "Редактирование",
            reviews: "Отзывы"
        }
    };
    let localeText = {
        url: process.env.NODE_ENV !== 'production' ? 'staticText/courseDetail.json' : 'staticText',
        main: {
            back: "к списку",
            blackList: "Вы не можете записываться на уроки этого учителя"
        }
    };

    import {store} from '../../../store/index'

    import {mapGetters} from 'vuex';

    import Tabs from '../../../vue_components/Tabs.vue'

		export default {
        data(){
            return {
                tabs: {},
                pageText: {}
			}
		},
        components: {
            'cmp-tabs': Tabs
		},
        computed: {
            ...mapGetters('profile', ['hasAuth']),
            ...mapGetters('coursesList', ['course']),
            ...mapGetters(['mobileState']),
            blackList(){
                if(!this.course.belonging)
                    return this.course.teacher.blackList;
                else
                    return false
            }
        },
		methods: {
            Load(pageText, tabs){
                this.pageText = pageText;
                this.tabs = tabs;
            }
		},
        beforeRouteUpdate (to, from, next) {
            store.dispatch('coursesList/LoadCourse', to.params).then((e) => {
                if(e){
                    next();
                } else{
                    next({name: 'courses'});
                }
            });
        },
		beforeRouteEnter (to, from, next) {
            let count = 0;

            let pageText = {},
				tabs = {};

            store.dispatch('staticText/LoadPageText', localeText).then((data) => {
                pageText = data;
                count++;
                RunNext();
            });
            store.dispatch('staticText/LoadTabsText', tabsText).then((data) => {
                tabs = data;
                count++;
                RunNext();
            });
            store.dispatch('staticText/LoadLessonText').then(() => {
                count++;
                RunNext();
            });
            store.dispatch('coursesList/LoadCourse', to.params).then((e) => {
                if(e){
                    count++;
                    RunNext();
                } else {
                    next({name: 'courses'});
                }
            });
            let RunNext = () => {
                if(count > 3)
                    next(vm => vm.Load(pageText, tabs))
            }
		}
	}
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/vue_pages/Courses/View/Index.vue